import { getHelpCenterTravelersQuestions, type HelpCenterRubric as IRubric } from '@/shared/api/helpCenter';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useTravelersStore = defineStore('travelers store', () => {
  const faqRubric = ref<IRubric>();

  const setFaqRubric = (rubric: IRubric) => {
    faqRubric.value = rubric;
  };

  const getTravelersQuestionsData = async () => {
    try {
      const { data, error } = await getHelpCenterTravelersQuestions({
        query: {
          with_answers: true,
        },
      });

      if (error || !data) {
        return;
      }

      setFaqRubric({
        title: 'Частые вопросы',
        slug: 'faq',
        rank: 1,
        questions: [...data.main_questions, ...data.other_questions],
      });

      return data;
    } catch (e) {
      console.log(e, 'e');
    }
  };

  return {
    faqRubric,
    getTravelersQuestions: getTravelersQuestionsData,
  };
});
